<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2.00615 7.11043L2.57855 12.2621C2.88239 14.9966 4.42036 17.442 6.75352 18.9002L11.47 21.848C11.7943 22.0507 12.2058 22.0507 12.53 21.848L17.2465 18.9002C19.5797 17.442 21.1177 14.9966 21.4215 12.2621L21.9939 7.11043C22.042 6.6774 21.8042 6.26305 21.4061 6.08614L12.4061 2.08736C12.1476 1.97251 11.8525 1.97251 11.594 2.08736L2.594 6.08614C2.19583 6.26305 1.95803 6.6774 2.00615 7.11043ZM4.07472 7.61677L12 4.09548L19.9253 7.61677L19.4337 12.0412C19.1974 14.1681 18.0012 16.07 16.1866 17.2042L12 19.8208L7.81352 17.2042C5.99884 16.07 4.80264 14.1681 4.56632 12.0412L4.07472 7.61677Z"
    fill="currentColor"
  />
</svg>
